import angular from "angular";
import uiRouter from "angular-ui-router";
import jobsComponent from "./jobs.component";

let jobsModule = angular
  .module("jobs", [uiRouter])
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider.state("jobs", {
      url: "/jobs",
      template: "<jobs></jobs>",
      title: "Jobs",
      params: {
        jobble_types: null,
        zipcode: null,
        query: null,
        query_zip: null,
      },
    });
  })

  .component("jobs", jobsComponent);

export default jobsModule;
/*?lat&lng&zipcode&ref&jts*/



// WEBPACK FOOTER //
// ./client/app/components/jobs/jobs.js